export const WIZARD_PAGE = {
  LOGGING_PERIOD: 'loggingperiod',
  ACTION_PLANS: 'actionplans',
  SILVICULTURE_PRICES: 'silviculturePrices',
  SILVICULTURE: 'silviculture',
  ENVIRONMENT_REPORT: 'environmentreport',
  ADDITIONS: 'additions',
  VOLUME_AND_ENTREPRENEUR: 'volumeAndEntrepreneur',
  ASSORTMENTS: 'assortments',
  TOPPLE_PLACES: 'toppleplaces',
  AGREEMENT: 'agreement',
  FINAL_DETAILS: 'finaldetails',
  SUMMARY: 'summary',
  COMBINED_SIGN_AND_FINISH: 'combinedSignAndFinish',
  DETAILS: 'details',
  QUOTE_DETAILS: 'quotedetails',
  SILVICULTURE_SUMMARY: 'silvicultureSummary',
  LOCATION: 'location',
  FINISH_QUOTE: 'finishQuote',
} as const

export type WizardPageId = (typeof WIZARD_PAGE)[keyof typeof WIZARD_PAGE]

export const SECTION_ID = {
  OPERATION: 'operation',
  VOLUME: 'volume',
  ENTREPRENEUR: 'entrepreneur',
  ENTREPRENEUR_CAPACITY: 'entrepreneurCapacity',
  LOCATION: 'location',
  TOPPLE_PLACES: 'toppleplaces',
  ASSORTMENTS: 'assortments',
  ADDITIONS: 'additions',
  FOREST_FUND: 'forestFund',
  COLLECTION_POINT: 'collectionPoint',
  SILVICULTURE_PRICES: 'silviculturePrices',
  YOUNG_FOREST_CARE_QUESTIONS: 'youngForestCareQuestions',
  STAND_INFORMATION: 'standInformation',
  SILVICULTURE_NOTES: 'silvicultureNotes',
  FINISH_ORDER: 'finishOrder',
  REGISTRATION_DETAILS: 'registrationDetails',
  DETAILS_STOCK_LEVEL: 'detailsStockLevel',
  DETAILS: 'details',
  ACTION_PLANS: 'actionplans',
  COMBINED_SIGN_AND_FINISH: 'combinedSignAndFinish',
  INTERNAL_NO: 'internalNo',
  LOGGING_PERIOD: 'loggingPeriod',
  OPERATION_PRICE: 'operationPrice',
  SCOPE: 'scope',
  GOALS_FOR_OPERATION_FINISHED: 'goalsForOperationFinished',
  ROAD_CONTACT: 'roadContact',
  ENVIRONMENT_REPORT_V2: 'environmentReportV2',
  QUOTE_DETAILS: 'quoteDetails',
  QUOTE_NAME: 'quoteName',
  QUOTE_NOTES: 'quoteNotes',
  SUMMARY: 'summary',
  LEGACY_SUMMARY: 'legacySummary',
  SILVICULTURE_ACTIONS_SUMMARY: 'silvicultureActionsSummary',
  SILVICULTURE_SUMMARY_NOTES: 'silvicultureSummaryNotes',
  SILVICULTURE_SUMMARY_MAP_IMAGES: 'silvicultureSummaryMapImages',
  ORDERS: 'orders',
  FINAL_DETAILS_NOTES: 'finalDetailsNotes',
  DOCUMENTS: 'documents',
  FINAL_DETAILS_ELIGIBILITY: 'finalDetailsEligibility',
  FINISH: 'finish',
} as const

export type WizardSectionId = (typeof SECTION_ID)[keyof typeof SECTION_ID]
